import { DarkThemeToggle } from 'flowbite-react';
import { Link } from 'react-router-dom';
import i18n from '../i18n';
import { useState } from 'react';

const Navbar = ({ address }) => {
  const [lang, setLang] = useState(i18n.language === 'ar' ? 'en' : 'ar');

  return (
    <nav className='flex justify-between items-center py-4'>
      <Link
        to='/'
        className='flex items-center justify-center text-2xl gap-2 hover:text-slate-800 dark:hover:text-slate-300 transition-colors'>
        {/* <img
          src='https://res.cloudinary.com/omar45/image/upload/v1667145453/NEAR/quizly_logo.png'
          alt='logo'
          className='max-w-[44px]'
        /> */}
        <svg
          className='w-10 h-10 text-primary-500'
          fill='none'
          stroke='currentColor'
          viewBox='0 0 24 24'
          xmlns='http://www.w3.org/2000/svg'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'></path>
        </svg>
        <h2 className='hidden sm:block logo-font text-3xl mt-1'>Quizly</h2>
      </Link>
      <div className='ml-auto mr-2'>
        <button
          className='rounded-lg p-2.5 text-sm font-semibold text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-4 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-670'
          onClick={() => {
            i18n.changeLanguage(i18n.language === 'en' ? 'ar' : 'en');
            setLang(i18n.language === 'en' ? 'ar' : 'en');
          }}>
          {lang.toUpperCase()}
        </button>
      </div>
      <div className='mr-4'>
        <DarkThemeToggle />
      </div>
      <Link
        title='Profile'
        to='/profile'
        className='inline-flex overflow-hidden relative justify-center items-center w-10 h-10 bg-primary-600 rounded-full '>
        <span className='font-semibold text-white'>
          {address ? address[0][0].toUpperCase() : 'P'}
        </span>
      </Link>
      {/* <Dropdown
          label={`${amount} NEAR`}
          style={{ backgroundColor: '#0D9488' }}>
          <Dropdown.Item
            onClick={() => {
              window.open(
                `https://explorer.testnet.near.org/accounts/${address}`,
                '_blank'
              );
            }}>
            <svg
              className='w-6 h-6 mr-2'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='1.5'
                d='M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z'></path>
            </svg>
            {address}
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item
            onClick={() => {
              destroy();
            }}>
            <svg
              className='w-6 h-6 mr-2'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='1.5'
                d='M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1'></path>
            </svg>
            Log Out
          </Dropdown.Item>
        </Dropdown> */}
    </nav>
  );
};

export default Navbar;
